module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_60yd_y.7e40c04f.csv";